@import (reference) '../../../../../constants/spacing.module.less';

.icon {
  height: 12px;
  width: 12px;
}

.whatsNextSection {
  margin-top: @space-24;
}

.nextStepsGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: @space-16;
  margin-top: @space-12;
}

.nextStepCard {
  padding: @space-16;
}

.link {
  display: flex;
  align-items: center;
  gap: @space-8;
}
